import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["padding"];
import { IconContainer } from './IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconBox = _ref => {
  let {
      padding = 'space-xs'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    alignItems: "center",
    blockSize: "inherit",
    border: "border",
    borderRadius: "border-radius-md",
    justifyContent: "center",
    padding: padding
  }));
};